var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearchHistory(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6093_12738)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.00001 2C3.55229 2 4.00001 2.44772 4.00001 3V7H8.00001C8.55229 7 9.00001 7.44772 9.00001 8C9.00001 8.55228 8.55229 9 8.00001 9H3.00001C2.44772 9 2.00001 8.55228 2.00001 8V3C2.00001 2.44772 2.44772 2 3.00001 2Z",
    fill: "#8A8A8D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.3696 2.03173C13.6075 1.89137 15.8276 2.50718 17.6733 3.78025C19.5191 5.05332 20.8835 6.90979 21.5473 9.0515C22.2112 11.1932 22.1359 13.4959 21.3338 15.5897C20.5316 17.6835 19.049 19.447 17.1241 20.5969C15.1991 21.7469 12.9436 22.2165 10.7197 21.9304C8.4958 21.6443 6.43257 20.6191 4.86137 19.0194C3.29016 17.4198 2.30217 15.3385 2.05605 13.1098C1.99543 12.5608 2.3913 12.0667 2.94024 12.006C3.48919 11.9454 3.98335 12.3413 4.04397 12.8902C4.24086 14.6732 5.03126 16.3382 6.28822 17.618C7.54518 18.8977 9.19576 19.7179 10.9749 19.9467C12.754 20.1756 14.5584 19.7999 16.0984 18.88C17.6383 17.96 18.8244 16.5493 19.4661 14.8742C20.1079 13.1991 20.1681 11.357 19.637 9.64363C19.1059 7.93026 18.0144 6.44508 16.5378 5.42662C15.0612 4.40816 13.2851 3.91552 11.4948 4.02781C9.70516 4.14006 8.00511 4.85033 6.66753 6.0446L6.66619 6.04579L3.66897 8.74329C3.25846 9.11275 2.62617 9.07948 2.25671 8.66897C1.88726 8.25846 1.92053 7.62617 2.33104 7.25671L5.33382 4.5542C7.00606 3.06047 9.1318 2.17209 11.3696 2.03173Z",
    fill: "#8A8A8D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 6C12.5523 6 13 6.44772 13 7V11.382L16.4472 13.1056C16.9412 13.3526 17.1414 13.9532 16.8944 14.4472C16.6474 14.9412 16.0468 15.1414 15.5528 14.8944L11.5528 12.8944C11.214 12.725 11 12.3788 11 12V7C11 6.44772 11.4477 6 12 6Z",
    fill: "#8A8A8D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6093_12738"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchHistory);
export default __webpack_public_path__ + "static/media/search-history.b13fc98b5bf790bda8df4823a0d89847.svg";
export { ForwardRef as ReactComponent };